<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid>
        <v-card class="green lighten-5">
            <Title title="観察項目の管理" />
            <v-container>
                <v-row>                    
                    <v-col cols="12">
                        <v-card>
                            <Title title="苗の観察項目" dense>
                                <v-spacer />
                                <v-btn icon @click="onClickAddNewItem(1)"><v-icon>mdi-plus-circle</v-icon></v-btn>
                                <!-- <v-btn icon @click="onClickEditGroup(group)"><v-icon>mdi-sort</v-icon></v-btn> -->
                            </Title>
                            <v-container>
                                <v-row>
                                    <template v-for="item in observateItems">
                                        <v-col 
                                            xs="12" sm="4" md="3" lg="2" xl="2"
                                            v-if="item.target == 1" 
                                            :key="item.id">
                                            <v-card>
                                                <v-card-title class="body-2">
                                                    {{item.name}}
                                                    <v-spacer />
                                                    <v-btn icon @click="onClickEditItem(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                                                </v-card-title>
                                                <!-- <table>
                                                    <tr>
                                                        <td><v-btn icon><v-icon>mdi-menu-left</v-icon></v-btn></td>
                                                        <td style="width:100%">
                                                            <v-card-title class="body-2">
                                                                {{item.name}}
                                                                <v-spacer />
                                                                <v-btn icon @click="onClickEditPlace(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                                                            </v-card-title>
                                                        </td>
                                                        <td><v-btn icon><v-icon>mdi-menu-right</v-icon></v-btn></td>
                                                    </tr>
                                                </table> -->
                                            </v-card>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-card>
                            <Title title="収穫物の観察項目" dense>
                                <v-spacer />
                                <v-btn icon @click="onClickAddNewItem(2)"><v-icon>mdi-plus-circle</v-icon></v-btn>
                                <!-- <v-btn icon @click="onClickEditGroup(group)"><v-icon>mdi-sort</v-icon></v-btn> -->
                            </Title>
                            <v-container>
                                <v-row>
                                    <template v-for="item in observateItems">
                                        <v-col 
                                            xs="12" sm="4" md="3" lg="2" xl="2"
                                            v-if="item.target == 2" 
                                            :key="item.id">
                                            <v-card>
                                                <v-card-title class="body-2">
                                                    {{item.name}}
                                                    <v-spacer />
                                                    <v-btn icon @click="onClickEditItem(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                                                </v-card-title>
                                            </v-card>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <template v-for="item in observateItems">
                            <v-card
                                :key="item.id"
                                v-if="item.target == 0">
                                <v-card-title class="body-2">
                                    {{item.name}}
                                    <v-spacer />
                                    <v-btn icon @click="onClickEditItem(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                                </v-card-title>
                            </v-card>
                        </template>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <Maintenance 
            ref="maintenance" 
            :observateItems="observateItems"
            />
        <!-- <Place ref="place" :places="places" :groups="groups" @onUpdatedPlace="onUpdatedPlace" />
        <Group ref="group" :groups="groups" /> -->
    </v-container>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Maintenance from '@/components/observate_item/MaintenanceObservateItem';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            Title,
            TitleButton,
            Maintenance,
            Confirm
        },
        computed: {
        },
        data: function () {
            return {
                observateItems:[]
            }
        },
        created: function () {
            console.log("ObservateItemManager", "created")
            const userUID = this.$store.getters["userUID"]
            const self = this

            this.observateItems = []

            try {
                // 登録済みの全観察項目取得
                db.collection("users").doc(userUID).collection("managements").doc("observate").collection("observate_items").get().then(function(snapShot){
                    snapShot.forEach(function(doc){
                        self.observateItems.push(doc.data())
                    })
                })

            } catch (error) {
                console.log(error)
            }
        },
        methods: {
            onClickAddNewItem: function (target) {
                this.$refs.maintenance.target = target
                this.$refs.maintenance.show()
            },
            onClickEditItem: function (item) {
                this.$refs.maintenance.target = item.target
                this.$refs.maintenance.show(item)
            },
        }
    }
</script>
